<script setup>
import { useForm } from "@inertiajs/vue3";
import VInputReadonlyWithLabel from "../../Form/VInputReadonlyWithLabel.vue";

const props = defineProps({
    additional: Object,
});

const { surveyFields, answers } = props.additional;

const form = useForm({
    survey_location: answers?.survey_location,
    district_of_residence: answers?.district_of_residence,
    gender: answers?.gender,
    marital_status: answers?.marital_status,
    age: answers?.age,
    ethnicity: answers?.ethnicity,
    current_employment: answers?.current_employment,
    income_level: answers?.income_level,
});

const emits = defineEmits("onNext");

const handleClickNext = () => {
    emits("onNext", form.data());
};
</script>

<template>
    <div>
        <div class="row">
            <div class="col-lg-12 mb-3">
                <div class="mb-3">
                    <VInputReadonlyWithLabel
                        elId="survey_location"
                        v-model:value="form.survey_location"
                        :label="surveyFields['survey_location']?.name"
                        :isPlainText="false"
                    />
                </div>

                <div class="mb-3">
                    <VInputReadonlyWithLabel
                        elId="district_of_residence"
                        v-model:value="form.district_of_residence"
                        :label="surveyFields['district_of_residence']?.name"
                        :isPlainText="false"
                    />
                </div>

                <div class="mb-3">
                    <VInputReadonlyWithLabel
                        elId="gender"
                        v-model:value="form.gender"
                        :label="surveyFields['gender']?.name"
                        :isPlainText="false"
                    />
                </div>

                <div class="mb-3">
                    <VInputReadonlyWithLabel
                        elId="marital_status"
                        v-model:value="form.marital_status"
                        :label="surveyFields['marital_status']?.name"
                        layout="vertical"
                        :isPlainText="false"
                    />
                </div>

                <div class="mb-3">
                    <VInputReadonlyWithLabel
                        elId="age"
                        v-model:value="form.age"
                        :label="surveyFields['age']?.name"
                        :isPlainText="false"
                    />
                </div>

                <div class="mb-3">
                    <VInputReadonlyWithLabel
                        elId="ethnicity"
                        v-model:value="form.ethnicity"
                        :label="surveyFields['ethnicity']?.name"
                        :isPlainText="false"
                    />
                </div>

                <div class="mb-3">
                    <VInputReadonlyWithLabel
                        elId="current_employment"
                        v-model:value="form.current_employment"
                        :label="surveyFields['current_employment']?.name"
                        :isPlainText="false"
                    />
                </div>

                <div class="mb-3">
                    <VInputReadonlyWithLabel
                        elId="income_level"
                        v-model:value="form.income_level"
                        :label="surveyFields['income_level']?.name"
                        :isPlainText="false"
                    />
                </div>
            </div>
        </div>
    </div>
</template>
